import { render, staticRenderFns } from "./EditDrawer.vue?vue&type=template&id=a27257a8&scoped=true"
import script from "./EditDrawer.vue?vue&type=script&lang=ts"
export * from "./EditDrawer.vue?vue&type=script&lang=ts"
import style0 from "./EditDrawer.vue?vue&type=style&index=0&id=a27257a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27257a8",
  null
  
)

export default component.exports